module.exports = new __parcel__URL__("arrow-down.67bd222b.svg").toString();